
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Tab4Table1 from "./Tab4Table1";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab4 = ({
  ItemCode,
  Default_Sales_Unit_of_Measure,
  Max_Discount,
  Allow_Sales,
  Grant_Commission,
  Reading_required,
  setselected_customer_details_data,
  selected_customer_details_data
}) => {

  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Sales Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input label="Default Sales Unit of Measure" readOnly value={Default_Sales_Unit_of_Measure.select_Default_Sales_Unit_of_Measure} style={{ height: '38px' }} />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-1">
            <Input
              readOnly
              id="Max_Discount"
              label="Max Discount (%)"
              style={{ height: "30px", }}
              value={Max_Discount.Max_Discount}
              onChange={(e) => Max_Discount.setMax_Discount(e.target.value)}
            />

          </div>
        </div>
        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              disabled={true}
              id="Allow_Sales"
              label="Allow Sales"
              value={Allow_Sales?.Allow_Sales || false}
              onChange={(val) => Allow_Sales?.setAllow_Sales?.(val)}
            />

          </div>
        </div>

        <div className="col-2 ">
          <div className="mb-3">
            <Checkbox
              disabled={true}
              id="Grant_Commission"
              label="Grant Commission"
              value={Grant_Commission?.Grant_Commission || false}
              onChange={(val) => Grant_Commission?.setGrant_Commission?.(val)}
            />

          </div>
        </div>
        <div className="col-4">
          <div className="mb-3">

            <Checkbox
              disabled={true}
              id="Reading_required"
              label="Reading required"
              value={Reading_required?.Reading_required || false}
              onChange={(val) => Reading_required?.setReading_required?.(val)}
            />
            <p style={{
              paddingLeft: '25px',
              paddingRight: '14px',
              fontWeight: 400,
              fontSize: '9px',
              letterSpacing: '0',
              color: '#00000099', fontFamily: 'Roboto, sans-serif',
            }} >
              If the item requires Gas or Electricity or similar meter reading to charge the customer.
            </p>
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Customer Details </p>
        </div>
        <Tab4Table1 setselected_customer_details_data={setselected_customer_details_data} selected_customer_details_data={selected_customer_details_data} />
      </div>
              <div>
              <ActivityCard doctype={'Item'} docname={ItemCode.ItemCode} />
          </div>

    </>
  );
};

export default Tab4;
